import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListCancelSubscriptionRequests from '../../components/reports/list-cancel-subscription-requests.component';

const CancelSubscriptionRequestsView = () => {
  const pageTitle = 'Analytics / Cancel Subscription Requests';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ListCancelSubscriptionRequests />
    </AppLayout>
  );
};

export default CancelSubscriptionRequestsView;
